import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";

export default function RouterConsumptionArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <img className="paragraph-image" src={imageMap.help.equipment.power_consumption} alt="Grafik der viser strømforbrug"/>
                    <div className="paragraph">
                        <p>
                            Din router bruger generelt strøm til at holde basis-systemet oppe for at være &ldquo;klar&rdquo; til internettrafik hele tiden.
                            Oven på dit basis-forbrug kommer der mere forbrug, når du bruger nettet.
                            Når du bruger dit wifi, koster det mere, end hvis du f.eks. kabler din forbindelse med et netværkskabel.
                            Jo flere enheder som er koblet til nettet, jo mere koster det i strøm.
                        </p>
                        <p>
                            Vi har testet en standardfamilies strømforbrug i primetime på vores Zyxel router EX3300-T0.
                            Strømforbruget var <strong>7,3 watt</strong> per time &ndash; det er 175 Watt-timer i døgnet.
                        </p>
                        <h3>Hvad koster det at have en router tændt hele døgnet?</h3>
                        <ul className="list list--bullet">
                            <li><p>
                                Tager vi dagens strømpriser, så koster en kWh i runde tal 3 kr.
                            </p></li>
                            <li><p>
                                Hvis vi antager at du bruger 0,175 Watt-timer i døgnet, koster det 0,175 &times; 3 = <strong>0,52 kr.</strong> i døgnet at have routeren kørende.
                            </p></li>
                        </ul>
                        <p>
                            Så hvis du gerne vil spare lidt på strømmen, kan du slukke din router om natten eller når du ikke bruger internettet.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "udstyr",
                        "article": "kan-jeg-bruge-mit-eget-udstyr",
                        "name": "Kan jeg bruge mit eget udstyr?"
                    },
                    {
                        "category": "udstyr",
                        "article": "installationsmanual",
                        "name": "Sådan installerer du din router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "ip-adresse",
                        "name": "IP-adresse"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    }
                ]}
            />
        </>
    )
}
